import { getNodesWithoutPlaceholders } from '../../utils';
import type { DnDProps } from './types';
import type { CustomNode } from '@src/components/custom-nodes/types';

type GetOnDragLeaveProps =
  Pick<DnDProps, 'reactFlowInstance'> & { setElementsSelectable: (value: boolean) => void };
export const getOnDragLeave = ({ reactFlowInstance, setElementsSelectable }: GetOnDragLeaveProps) => () => {
  const nodes = reactFlowInstance?.getNodes() as CustomNode[];
  const setNodes = reactFlowInstance?.setNodes;

  const nodesWithoutPlaceholders = getNodesWithoutPlaceholders(nodes);
  setNodes?.(() => nodesWithoutPlaceholders);
  setElementsSelectable(true);
};
